import React from 'react'
import { Link } from 'react-router-dom'


const WhatssapIcon = () => {
    return (
        <div>


            <Link
                to="https://wa.me/+212640033322"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-8 right-8 z-50 group flex items-center justify-center"
            >
                {/* The "Pim Pim" Ping Effect (Slowed down to 2s) */}
                <span className="absolute h-full w-full rounded-full bg-green-500 opacity-75 animate-[ping_2s_linear_infinite]"></span>

                {/* The Main Icon with a gentle float animation */}
                <img
                    src='/assets/images/whatsapp.png'
                    alt='whatsapp'
                    className="relative w-14 h-14 rounded-full shadow-[0_10px_25px_rgba(0,0,0,0.3)]"
                />
            </Link>


        </div>
    )
}

export default WhatssapIcon